import React, { createContext, useContext, useMemo, useState } from 'react';
import { useAppDispatch } from '../../../../../hooks/redux';
import FavoriteProductTagsModal from '../../../../../components/favoriteproductTagModal/FavoriteProductTagsModal';
import {
    deleteFavoriteProductTagAction,
    getFavoriteProductTagsByFavoriteProductIdAction
} from '../../../../../redux/actions/favoriteProductTagActions';
import { alertService } from '../../../../../services';

type FavoriteProductTagsContextType = {
    open: (favoriteProductId: number) => void;
    close: () => void;
    deleteTag: (favoriteProductTagId: number) => void;
};

export const FavoriteProductTagsContext = createContext<FavoriteProductTagsContextType>({
    open: () => { },
    close: () => { },
    deleteTag: (_favoriteProductTagId: number) => { },
});

export const useFavoriteProductTags = () => useContext(FavoriteProductTagsContext);

export const FavoriteProductTagsProvider: React.FC<{ children: any; onSaved?: () => void }> = ({ children, onSaved }) => {
    const dispatch = useAppDispatch();

    const [visible, setVisible] = useState(false);
    const [favoriteProductId, setFavoriteProductId] = useState<number | null>(null);

    const open = (id: number) => {
        setFavoriteProductId(id);
        setVisible(true);
        dispatch(getFavoriteProductTagsByFavoriteProductIdAction(id));
    };

    const close = () => {
        setVisible(false);
        setFavoriteProductId(null);
    };

    const handleDeleteFavoriteProductTag = async (favoriteProductTagId: number) => {
        if (!favoriteProductTagId) {
            return;
        }
        try {
            await dispatch(deleteFavoriteProductTagAction(favoriteProductTagId));
            alertService.success('Tag removed');
        } catch (e) {
            console.error(e);
            alertService.error('Failed to remove tag');
        }
    };

    const contextValue = useMemo(() => ({
        open,
        close,
        deleteTag: handleDeleteFavoriteProductTag,
    }), [open, close, handleDeleteFavoriteProductTag]);
    return (
        <FavoriteProductTagsContext.Provider value={contextValue}>
            {children}
            <FavoriteProductTagsModal visible={visible} favoriteProductId={favoriteProductId} onClose={close} onSaved={onSaved} />
        </FavoriteProductTagsContext.Provider>
    );
};

export default FavoriteProductTagsContext;
